#import "../fragments/potential-activity-entity-fragment.graphql"

mutation ActivityCreateOrMergeContactFromExternalAttendee(
    $input: ActivityCreateOrMergeContactFromExternalAttendeeInput!
) {
    activityCreateOrMergeContactFromExternalAttendee(input: $input) {
        activity {
            id
            participants {
                ...PotentialActivityEntityFragment
            }
        }
        contact {
            ...PotentialActivityEntityFragment
        }
    }
}
